import React from 'react'
import CardColumns from 'react-bootstrap/CardColumns'
import EstateCard from './estateCard'

const EstateList = (props) => {

    return (
        <>
            <CardColumns className="mt-3 cardit">
                {props.cardList !== 'No estates found' && props.cardList.map((item, index) => (
                    <EstateCard
                        key={index}
                        base_url={props.base_url}
                        api_key={props.api_key}
                        updateEstate={props.updateEstate}
                        viewEstateDetails={props.viewEstateDetails}
                        cardData={props.cardList[index]}
                        index={index}
                        editable={props.editable}
                        FetchList={props.FetchList}
                    />
                ))}
                {props.cardList === 'No estates found' &&

                    <p>No hay ninguna propiedad</p>

                }
            </CardColumns>
        </>
    )
}
export default EstateList